import UserAvatarList from '~/vue_shared/components/user_avatar/user_avatar_list.vue';
export default {
    name: 'ApprovalsUsersList',
    components: {
        UserAvatarList
    },
    props: {
        label: {
            type: String,
            required: true
        },
        users: {
            type: Array,
            required: true
        }
    }
};
